(function () {
  'use strict';

  function getContactPhone(attrs) {
    var keys = ['Contact Phone', 'Pickup Phone', 'Delivery Phone'];
    var i;
    var phone;
    attrs = attrs || {};
    for (i = 0; i < keys.length; i += 1) {
      phone = attrs[keys[i]];
      if (typeof phone === 'string' && phone.trim()) {
        return phone.trim();
      }
    }
    return '';
  }

  function isValidContactPhone(raw) {
    if (typeof raw !== 'string') {
      return false;
    }
    var phone = raw.replace(/[\s\-().]/g, '');
    return /^(?:\d{10}|1\d{10})$/.test(phone) || /^\+\d{7,15}$/.test(phone);
  }

  function isReady(attrs) {
    attrs = attrs || {};
    var method = attrs['Fulfillment Method'];
    return typeof method === 'string' && method.trim() !== '' &&
      isValidContactPhone(getContactPhone(attrs));
  }

  window.CakeMiamiFulfillmentGate = {
    getContactPhone: getContactPhone,
    isValidContactPhone: isValidContactPhone,
    isReady: isReady
  };
}());
